import { c as _c } from "react/compiler-runtime";
import type { IconProps } from "./icon-base";
export default function CssLogo(props) {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <linearGradient gradientUnits="userSpaceOnUse" id="css-id4" x1="54128.7" x2="240318" y1="79355.5" y2="79355.5"><stop offset="0" stopColor="#e8e7e5" /><stop offset="1" stopColor="#fff" /></linearGradient>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <linearGradient gradientUnits="userSpaceOnUse" id="css-id5" x1="62019.3" x2="233515" y1="202868" y2="202868"><stop offset="0" stopColor="#e8e7e5" /><stop offset="1" stopColor="#fff" /></linearGradient>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <linearGradient gradientUnits="userSpaceOnUse" id="css-id6" x1="104963" x2="104963" y1="99616.9" y2="171021"><stop offset="0" stopColor="#d1d3d4" /><stop offset=".388" stopColor="#d1d3d4" /><stop offset="1" stopColor="#d1d3d4" /></linearGradient>;
    t3 = <linearGradient gradientUnits="userSpaceOnUse" id="css-id7" x1="194179" x2="194179" xlinkHref="#css-id6" y1="61185.8" y2="135407" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <mask id="css-id0"><linearGradient gradientUnits="userSpaceOnUse" id="css-id1" x1="104963" x2="104963" y1="99616.9" y2="171021"><stop offset="0" stopColor="#fff" stopOpacity="0" /><stop offset=".388" stopColor="#fff" /><stop offset="1" stopColor="#fff" stopOpacity=".831" /></linearGradient><path d="M61737 99467h86453v71704H61737z" fill="url(#css-id1)" /></mask>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs>{t0}{t1}{t2}{t3}{t4}<mask id="css-id2"><linearGradient gradientUnits="userSpaceOnUse" id="css-id3" x1="194179" x2="194179" y1="61185.8" y2="135407"><stop offset="0" stopColor="#fff" stopOpacity="0" /><stop offset=".388" stopColor="#fff" /><stop offset="1" stopColor="#fff" stopOpacity=".831" /></linearGradient><path d="M147890 61036h92578v74521h-92578z" fill="url(#css-id3)" /></mask></defs>;
    t6 = <g><path d="M268517 300922l-120369 32411-120371-32411L0 0h296297z" fill="#2062af" /><path d="M148146 24374v283109l273 74 97409-26229 22485-256954z" fill="#3c9cd7" /><path d="M148040 99617l-86153 35880 2857 35524 83296-35614 88604-37883 3674-36339-92278 38432z" fill="#fff" /><path d="M61887 135497l2857 35524 83295-35614V99617z" fill="url(#css-id6)" mask="url(#css-id0)" /><path d="M240318 61186l-92278 38431v35790l88604-37883z" fill="url(#css-id7)" mask="url(#css-id2)" /><path d="M62019 135497l2858 35524 127806 407-2859 47365-42055 11840-40428-10208-2450-29399H67327l4900 56756 75950 22457 75538-22050 9800-112692z" fill="url(#css-id5)" /><path d="M148040 135497H61888l2857 35524 83295 266v-35790zm0 95022l-408 114-40422-10208-2450-29399H67197l4899 56756 75944 22457v-39720z" fill="#000" fillOpacity=".05098" /><path d="M54129 61186h186189l-3674 36339H58620l-4491-36339z" fill="url(#css-id4)" /><path d="M148040 61186H54129l4491 36339h89420z" fill="#000" fillOpacity=".05098" /></g>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== props) {
    t7 = <svg aria-label="CSS logo" clipRule="evenodd" fillRule="evenodd" imageRendering="optimizeQuality" role="graphics-symbol" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 296297 333333" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>{t5}{t6}</svg>;
    $[7] = props;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}